<template>
  <a-range-picker v-bind="$attrs" />
</template>

<script lang="ts">
export default {
  name: 'CRangePicker',
}
</script>

<style scoped></style>
